import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { catchError, Observable, of } from "rxjs";
import { environment } from "../../environments/environment";
import { NaicsCode } from "../models/naics-code.model";

/**
 * PURPOSE: responsible for making all NAICS related HTTP API calls
 */
@Injectable({
  providedIn: "root"
})
export class NaicsService {
  constructor(private http: HttpClient) {}

  /**
   * Retrieves a List of 6 digit NAICS codes
   */
  public getSixDigitNaicsCodes(): Observable<NaicsCode[]> {
    return this.http
      .get<
        NaicsCode[]
      >(`${environment.fulcrumUrl}/api/v1/industry/codes/6D`, this.buildBasicHttpOptions())
      .pipe(
        catchError((error: HttpErrorResponse): Observable<NaicsCode[]> => {
          if (error.status === 404) {
            console.log("Not Found");
            return of(new Array<NaicsCode>());
          }
          console.log(error);
          throw error;
        })
      );
  }

  private buildBasicHttpOptions() {
    return {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization:
          "Basic " + btoa(`${environment.claimItApiUsername}:${environment.claimItApiPassword}`)
      }),
      params: {}
    };
  }
}
